import { createFileRoute } from '@tanstack/react-router'
import { useCallback, useState } from 'react'
import { useCurrentOrganization } from '~/hooks'
import { FileUploadMutators } from '~/mutators/file-uploads'

import { Button, Heading1 } from '@hap/components'

import { FileUploadField } from '~/features/file-upload'

export const Route = createFileRoute('/_authenticated/$alias/v2/generate')({
  component: RouteComponent,
})

function RouteComponent() {
  // const navigate = Route.useNavigate()
  const organization = useCurrentOrganization()
  const [fileDetails, setFileDetails] = useState<{
    name: string
    fileId?: string
  } | null>(null)

  // const { startStream } = WizardMutators.useCreateJob()

  const { upload } = FileUploadMutators.useFileUpload({
    associatedCollection: 'users',
    associatedWith: organization?.id,
    cropToSquare: false,
    onSuccess: () => {
      console.log('uploaded!')
    },
    onError: () => {
      console.log('on error!')
    },
  })

  // const { create } = ScorecardMutators.useCreate()

  const uploadFile = useCallback(
    async (file: File) => {
      console.log(file)
      setFileDetails({ name: file.name })
      const fileId = await upload(file)
      console.log({ fileId })
      setFileDetails({ name: file.name, fileId })
    },
    [upload],
  )

  const submit = useCallback(async () => {
    if (!fileDetails?.fileId) return
    // const scorecard = await create({
    //   name: 'New Scorecard',
    //   resources: [{ type: 'file-upload', id: fileDetails.fileId }],
    // })
    // const job = await startStream({
    //   rubricFileUploadId: fileDetails.fileId,
    //   scorecardId: scorecard.id,
    // })

    // navigate({
    //   to: '/$alias/wizard/edit/$scorecardId',
    //   params: { scorecardId: scorecard.id },
    //   search: { jobId: job.streamId },
    // })
  }, [fileDetails?.fileId])

  return (
    <div className="bg-accent fixed inset-0 z-10 flex items-center justify-center">
      <div className="w-full max-w-3xl space-y-10 px-6">
        <header>
          <Heading1>Upload your scorecard</Heading1>
        </header>
        <FileUploadField
          accept={ACCEPTED_EXTENSIONS}
          selectedFileName={fileDetails?.name ?? null}
          onFileSelect={uploadFile}
          onClear={() => setFileDetails(null)}
          description="PDF, Word, Excel, TXT, CSV, MD (max 1MB each)"
        />
        {fileDetails && (
          <Button size="lg" variant="lime" className="w-full" onClick={submit}>
            Import
          </Button>
        )}
      </div>
    </div>
  )
}

const ACCEPTED_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.txt',
  '.csv',
  '.md',
]
